@if (useGradient()) {
  <div class="spl-ui-avatar__gradient" [style.background]="useGradient()">
    {{ userInitials() }}
  </div>
} @else {
  <img class="spl-ui-avatar__picture" [src]="picture()" alt="User Picture" (error)="handlePictureLoadFailure()" />
}
